var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('label',{class:{ 'sr-only': _vm.showLabel === 'false' }},[_vm._v("Change Organization")]),_c('OrganizationSelectV2',{attrs:{"placeholderText":_vm.placeholderText},on:{"organizationSelected":_vm.organizationChanged}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }